import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Authorization header from localStorage as fallback (some Safari/iOS cookie issues)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ds_access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function getToken() {
  return localStorage.getItem("ds_access_token") || "";
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_LABELS = {
  pendiente: "Pendiente",
  enviado_al_conductor: "Enviado al conductor",
  en_espera: "En espera",
  en_revision: "En revisión",
  no_presentada: "No presentada",
  resuelta: "Resuelta",
  multada: "Multada",
};

export const SERVICE_STATUS_ORDER = [
  "pendiente_asignacion",
  "asignado",
  "en_camino",
  "a_bordo",
  "finalizado",
  "no_show",
  "cancelado",
];

export const SERVICE_STATUS_LABELS = {
  pendiente_asignacion: "Pendiente asignación",
  asignado: "Asignado",
  en_camino: "En camino",
  a_bordo: "A bordo",
  finalizado: "Finalizado",
  no_show: "No show",
  cancelado: "Cancelado",
};

export const SERVICE_STATUS_COLORS = {
  pendiente_asignacion: "#52525B",
  asignado: "#0284C7",
  en_camino: "#D97706",
  a_bordo: "#7C3AED",
  finalizado: "#16A34A",
  no_show: "#E63946",
  cancelado: "#0A0A0A",
};

export const DRIVER_STATUSES = ["en_camino", "a_bordo", "finalizado", "no_show"];

export const STATUS_ORDER = [
  "pendiente",
  "enviado_al_conductor",
  "en_espera",
  "en_revision",
  "no_presentada",
  "resuelta",
  "multada",
];

export const STATUS_COLORS = {
  pendiente: "#52525B",
  enviado_al_conductor: "#0284C7",
  en_espera: "#D97706",
  en_revision: "#7C3AED",
  no_presentada: "#0A0A0A",
  resuelta: "#16A34A",
  multada: "#E63946",
};

export default api;
